import React, { useEffect } from "react"
import { logoutUser } from "../../store/actions"
//redux
import { useDispatch } from "react-redux"

const Logout = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(logoutUser())
  }, [dispatch])

  return <></>
}

export default Logout
